import { render, staticRenderFns } from "./programEnrollmentCommittee.vue?vue&type=template&id=bbf3c014&scoped=true&"
import script from "./programEnrollmentCommittee.vue?vue&type=script&lang=js&"
export * from "./programEnrollmentCommittee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf3c014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
